"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMediasQueryDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchMediasQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    mediaId;
    search;
    mediaTypes;
    owners;
    withPrice;
    viewVrmefy;
    viewHighlighted;
    viewPublished;
    emitFrom;
    emitTo;
    from;
    to;
    flatten;
}
exports.SearchMediasQueryDto = SearchMediasQueryDto;
